import { FC } from "react";
import MainSettings from "@web-src/modules/settings/pages/MainSettings";
import { CXWorkspaceSettingsLayout } from "../CXWorkspaceSettingsLayout";

export const CXWorkspaceMyAccountPage: FC = () => (
  <CXWorkspaceSettingsLayout>
    <MainSettings />
  </CXWorkspaceSettingsLayout>
);
